import { MissionToStaff } from '../../lib/types/models/mission-to-staff/mission-to-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function cancelStaff(input: { id: number; staffId: number; cancellationReason?: string }) {
  const { id, staffId, cancellationReason } = input
  return restApiClient
    .url(constructApiUrl(API.missions.cancelStaff.url, { id, staffId }))
    .post<MissionToStaff>({ cancellationReason })
}
